module.exports = __webpack_public_path__ + "static/media/Event3.c02cbe74.jpg";